import React from "react";
import { useTranslation } from "react-i18next";
import { Button, Grid, Tooltip } from "@mui/material";
import { airMetricConfig, airMetricOrder, TAB_COLORS } from "../../constants/airQuality";

/**
 * I cinque pulsanti delle grandezze (ozono, AQI, PM1, PM2.5, PM10) con il numero di campioni
 * fra parentesi; una grandezza senza campioni è disabilitata con `missingTitle` nel tooltip.
 *
 * @param countByMetric { [metricKey]: number }
 */
export default function MetricButtons({ selectedMetricKey, onSelect, countByMetric, missingTitle }) {
    const { t } = useTranslation();
    return (
        <Grid container justifyContent="center" spacing={1}>
            {airMetricOrder.map(metricKey => {
                const cfg = airMetricConfig[metricKey];
                const color = TAB_COLORS[airMetricOrder.indexOf(metricKey)] || TAB_COLORS[0];
                const isActive = metricKey === selectedMetricKey;
                const count = (countByMetric && countByMetric[metricKey]) || 0;
                const available = count > 0;
                const title = available ? t(cfg.descriptionTranslationKey) : missingTitle;
                return (
                    <Grid item key={metricKey}>
                        <Tooltip title={title || ""} arrow>
                            <span>
                                <Button
                                    size="small"
                                    variant={isActive ? "contained" : "outlined"}
                                    disabled={!available}
                                    onClick={() => onSelect(metricKey)}
                                    sx={{
                                        textTransform: "none",
                                        borderColor: color,
                                        color: isActive ? "#fff" : color,
                                        bgcolor: isActive ? color : "transparent",
                                        "&:hover": { bgcolor: isActive ? color : `${color}22`, borderColor: color },
                                    }}
                                >
                                    {t(cfg.titleTranslationKey)}
                                    {available ? ` (${count})` : ""}
                                </Button>
                            </span>
                        </Tooltip>
                    </Grid>
                );
            })}
        </Grid>
    );
}
